module.exports = __webpack_public_path__ + "img/2012-08-18 13.15.17.a5aec796.jpg";